var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinCodeMapping(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 99,
    rx: 11.5,
    fill: "#F8FBFF",
    stroke: "#EBF1FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9946 57.5186C32.3333 57.5186 31.2963 57.9864 30.9205 59.5926L23.1427 82.9259C22.7279 84.5852 23.3155 85 23.6612 85H74.476C76.9649 85 76.8958 83.6173 76.5501 82.9259L68.7723 59.5926C68.1111 57.5186 67.0741 57.5186 65.5186 57.5186H65.5185H32.9946Z",
    fill: "#E6EDFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3326 73.0742C31.7838 73.0742 30.923 73.2155 30.6111 73.7004L28.1851 80.3335C27.6666 81.3705 28.4471 81.3705 28.734 81.3705H70.9107C71.7408 81.3705 72.2593 81.3705 72.2593 80.3335L70.3248 73.7004C69.776 73.0742 68.9153 73.0742 67.6242 73.0742H67.6241H32.3326Z",
    fill: "#FFD164"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9937 61.6665C34.5163 61.6665 33.7675 61.8077 33.4962 62.2926L31.3857 68.9258C31.0862 69.4267 31.6137 69.9628 31.8632 69.9628H68.5529C69.6667 69.9628 69.6667 69.4443 69.6667 68.9258L68.0432 62.2926C67.5658 61.6665 66.817 61.6665 65.6939 61.6665H65.6939H34.9937Z",
    fill: "#FFD164"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.4773 77.1903C44.1563 71.1409 35.0995 57.7977 33.4402 52.82C30.5019 47.2891 26.1809 33.9459 32.4032 24.8199C35.86 19.2891 46.6106 10.1977 61.9587 18.0792C66.7982 20.8446 75.2328 30.1088 70.255 45.0422C68.6995 49.0175 63.8592 57.8296 59.2963 65.2963L52.1069 77.1903C51.5062 78.0545 49.9393 79.2644 48.4773 77.1903ZM51 53.3704C60.1638 53.3704 67.5926 45.9416 67.5926 36.7778C67.5926 27.6139 60.1638 20.1852 51 20.1852C41.8361 20.1852 34.4074 27.6139 34.4074 36.7778C34.4074 45.9416 41.8361 53.3704 51 53.3704Z",
    fill: "#47C1DC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4912 37.2963C34.3209 21.9482 45.9357 16.037 51.6394 15C36.2912 15 29.3431 26.9259 29.3431 34.1852C27.7875 49.7408 41.6147 68.2346 49.0468 77.2222C50.2913 78.8815 51.2938 78.2593 51.6394 77.7408L52.6764 75.6667C36.4986 56.5852 33.1455 42.1358 33.4912 37.2963Z",
    fill: "#1FACCB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0056 26.0167C44.464 26.1426 44.0262 27.5111 44 28.1797L44.059 43.9886C44.0275 45.5302 45.3305 46.086 45.986 46.1712H57.4691C57.8781 46.2184 57.9803 45.9156 57.9803 45.7583V44.8342H45.8483C45.1562 44.1892 45.6517 43.6871 45.986 43.5167H57.9803V26.587C57.8545 26.0049 57.2594 25.9643 56.9775 26.0167H46.0056Z",
    fill: "#8993DA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9073 42.2809L57.9017 42.2612H58V43.5H46.0056C45.1405 44.0191 45.5796 44.6208 45.9073 44.8567H58V45.5843C57.9528 46.182 57.5084 46.2004 57.2921 46.1348H45.9073C44.5545 45.8517 44.1639 44.9551 44.1377 44.5421C43.886 42.9691 45.2126 42.3792 45.9073 42.2809Z",
    fill: "#5766CB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46.3596,
    y: 28.0449,
    width: 9.24157,
    height: 5.26966,
    rx: 2,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 46.7135,
    y: 39.4492,
    width: 4.28652,
    height: 0.668539,
    rx: 0.33427,
    fill: "#FBD55B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 46.7135,
    y: 40.5112,
    width: 4.28652,
    height: 0.668539,
    rx: 0.33427,
    fill: "#E7A52E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinCodeMapping);
export default __webpack_public_path__ + "static/media/pin-code-mapping.c89b03f3722ed2b6af225ec83bf28093.svg";
export { ForwardRef as ReactComponent };